/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ConfigurationInputs */



/**
* | output |
* | --- |
* | "Configuration" |
*
* @param {ConfigurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const configuration = /** @type {((inputs?: ConfigurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ConfigurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configuration")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfiguration")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конфигурация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("構成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विन्यास")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configuração")
	return /** @type {LocalizedString} */ ("Configuration")
});